// @flow
import React from "react";
import styled from "styled-components";
import { connect, type MapStateToProps } from "react-redux";
import ProjectTitle from "../ProjectTitle";
import { fontSize } from "../common/styled-mixins";
import { mapStateToCurrency } from "../Money";
import { withDeposit } from "../common/withDeposit";
import Gettext from "../common/Gettext";

import type { State as ServerData } from "../../redux/reducer/serverData";
import type { State as ApiConfigs } from "../../redux/reducer/apiConfigs";
import type { State as ReduxState } from "../../redux/reducer";
import { isIronTerminal } from "../utils";

const FooterView = styled.footer`
  padding: 50px 0 20px 0;
  color: #919191;
  background-color: #f5f5f5;
`;

const CenterContainer = styled.div`
  width: 940px;
  margin: 0 auto;
  position: relative;

  @media screen and (max-width: 960px) and (min-width: 800px) {
    width: 780px;
  }

  @media screen and (max-width: 799px) {
    width: 100%;
  }
`;

const Copyright = styled.div`
  direction: ${(props) => props.theme.direction};
  font-weight: 400;
  font-size: ${fontSize(14)};
  text-align: center;
`;

type Props = {
  className?: string,
  serverData: ServerData,
  apiConfigs: ApiConfigs,
  showDeposit: boolean,
};




function Footer(props: Props) {
  const { className } = props;

  const CurrentYear = () => {
    const date = new Date();
    return date.getFullYear();
  };

  try {
    if (isIronTerminal()) return null;


    return (
      <FooterView className={className}>
        <CenterContainer>
          <Copyright>
            &copy; <CurrentYear />{" "}
            {process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? (
              <ProjectTitle />
            ) : (
              <Gettext>Rosco Solutions LTD</Gettext>
            )}
            . <Gettext>All rights reserved</Gettext>.
          </Copyright>
        </CenterContainer>
      </FooterView>
    );
  } catch (err) {
    return null;
  }
}

const mapStateToProps = (state: ReduxState) => ({
  serverData: state.serverData,
  apiConfigs: state.apiConfigs,
  profile: state.profile,
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(
  connect(mapStateToCurrency)(withDeposit(Footer))
);



// WEBPACK FOOTER //
// ./src/components/IndexPage/IronFooter.js